import { render, staticRenderFns } from "./ccHxpCensus.vue?vue&type=template&id=8ce3ca4a&scoped=true&"
import script from "./ccHxpCensus.vue?vue&type=script&lang=js&"
export * from "./ccHxpCensus.vue?vue&type=script&lang=js&"
import style0 from "./ccHxpCensus.vue?vue&type=style&index=0&id=8ce3ca4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce3ca4a",
  null
  
)

export default component.exports